import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DateTime } from 'luxon';
import { Subject } from 'rxjs';

interface DailyCap {
  id: string;
  carrierId: string;
  date: Date;
  cap: number;
  dayShiftCap: number;
  nightShiftCap: number;
  createdAt: DateTime;
  updatedAt: DateTime;
}

@Component({
  selector: 'lohi-cap-form-field-component',
  templateUrl: './cap-form-field-component.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class CapFormFieldComponentComponent implements OnInit, OnDestroy {

  private destroy$$ = new Subject();

  public cap = new FormControl();

  constructor() {
  }

  @Input() public capData: DailyCap;

  public ngOnInit() {
    this.cap.setValue(this.capData.cap);
    this.cap.valueChanges.subscribe((value) => {
      this.capData.nightShiftCap = Math.ceil(value / 2);
      this.capData.dayShiftCap = Math.floor(value / 2);
    });
  }

  public ngOnDestroy(): void {
    this.destroy$$.next();
    this.destroy$$.unsubscribe();
  }

}
